import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import UserService from '../../../../../services/users-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Fiscal = () => {
    let { id } = useParams()

    const [senha, setSenha] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState("");

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const fiscal = await UserService.senha(id, {
                senha: senha
            })
            if (fiscal.data["cod_fiscal"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={3}>
                        <Col>
                            <Form.Group className="mb-3" controlId="senha">
                                <FloatingLabel
                                    label="Senha"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="senha"
                                        value={senha}
                                        onChange={e => setSenha(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/usuarios/listar'}>
                    <Button variant="danger" type="button">
                        Cancelar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Senha alterada com sucesso!</Alert>
                <Navigate to={'/restrito/usuarios/listar'} />
            </Fragment>
        )
    }
}

export default Fiscal;